var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assess-nav"},_vm._l((_vm.assessNavList),function(item,index){return _c('div',{key:index,class:[
            'assess-nav-item ',
            { actived: _vm.actived == item.review_id } ],on:{"&click":function($event){return _vm.handleNav(item, index)}}},[_c('span',[_vm._v(_vm._s(item.review_name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }